import { useEffect, useState, useRef } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { useFormik } from 'formik'
import { loginNew } from '../core/_requests'
import Toast from 'react-bootstrap/Toast'
import { ToastContainer } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { setMessage } from 'src/store/alertMessage/actions'
import { FormattedMessage, useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../core/Auth'

export function Login() {
  const intl = useIntl()
  const navigate = useNavigate();
  const loginSchema = Yup.object().shape({
    mobileno: Yup.string()
      .matches(/^[6-9]\d{9}$/, 'Mobile number cannot start with from 0 to 5')
      .min(10, 'Mobile number must be at least 10 digit')
      .max(10, 'Mobile number must be 10 digit')
      .required('Mobile number is required'),
    password: Yup.string()
      .min(7, 'Password must be at least 7 characters')
      .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
      .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
      .matches(/\d/, 'Password must contain at least one number')
      .matches(/[\W_]/, 'Password must contain at least one special character')
      .required('Password is required'),
  })

  const initialValues = {
    mobileno: '',
    password: '',
  }
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const [sessionMessage, setSessionMessage] = useState({
    type: '',
    message: '',
    show: false,
  })
  const inputRef = useRef<any>(null);
  useEffect(() => {
    if (inputRef.current) {
      inputRef?.current?.focus();
    }
  }, []);
  useEffect(() => {
    if (sessionMessage.show) {
      setTimeout(() => {
        setSessionMessage({ type: '', message: '', show: false })
      }, 4500)
    }
  }, [sessionMessage.message])
  const { saveAuth, saveCurrentUser } = useAuth();


  //  const navigate = useNavigate();
  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true);
      try {

        const response = await loginNew(values.mobileno, values.password);
        const dataNew: any = response.data;



        if (dataNew?.token) {
          localStorage.setItem("authtoken", dataNew.token);
          saveAuth(dataNew.token);
          if (Array.isArray(dataNew.branch)) {
            localStorage.setItem("branch", JSON.stringify(dataNew.branch[0]));
            localStorage.setItem("id", dataNew.branch[0].id);
            saveCurrentUser(dataNew.branch[0].id);
          }
          dispatch(setMessage("success", `${intl.formatMessage({ id: 'LOGIN_SUCCESSFULLY' })}`, 1));
          navigate("/dashboard")
          // setTimeout(() => {
          //   window.location.href = "/dashboard";
          // }, 2500);
        }
      } catch (error: any) {
        setLoading(false);
        setSubmitting(false);

        if (error.response) {
          const errorData = error.response.data;

          if (errorData?.Error?.message) {
            setStatus(errorData.Error.message);
            dispatch(setMessage("error", errorData.Error.message));
          } else {
            setStatus("Something went wrong. Please try again.");
            dispatch(setMessage("error", `${intl.formatMessage({ id: 'SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN' })}`));
          }
        } else {
          setStatus("Network error. Please try again.");
          dispatch(setMessage("error", `${intl.formatMessage({ id: 'NETWORK_ERROR_PLEASE_TRY_AGAIN' })}`));
        }

        console.error("Login Error:", error);
      }
    },
  });



  const handleUppercaseInput = (e: any) => {
    e.target.value = e.target.value.trimStart();
    e.target.value = e.target.value.replace(/\D/g, '');
    formik.handleChange(e);
  };
  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'

    >
      {/* begin::Heading */}

      <div className='text-center mb-11'>
        <h1 className='text-dark fs-1 fw-bolder mb-3'>Login</h1>
      </div>

      {/* begin::Form group */}
      <div className='fv-row mb-8'>
        <input
          placeholder='Mobile Number'
          ref={inputRef}
          onChange={handleUppercaseInput}
          className={clsx(
            'form-control bg-transparent',
            { 'is-invalid': formik.touched.mobileno && formik.errors.mobileno },
            {
              'is-valid': formik.touched.mobileno && !formik.errors.mobileno,
            }
          )}
          type='text'
          name='mobileno'
          autoComplete='off'
          maxLength={10}
        />
        {formik.touched.mobileno && formik.errors.mobileno && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.mobileno}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      {/* <div className='fv-row mb-3'>
        <input
          type='password'
          placeholder='Password'
          autoComplete='off'
          {...formik.getFieldProps('password')}
          onChange={(e) => {
            // Trim the input value
            e.target.value = e.target.value.trim();
            // Update Formik state
            formik.handleChange(e);
          }}
          onKeyDown={(e) => {
            // List of characters to block
            const forbiddenChars = ['<', '>', '.', '?', '/','\\', '"', "'", ':', ';',','];
            if (forbiddenChars.includes(e.key)) {
              e.preventDefault(); // Prevent the input
            }
          }}
          className={clsx(
            'form-control bg-transparent',
            {
              'is-invalid': formik.touched.password && formik.errors.password,
            },
            {
              'is-valid': formik.touched.password && !formik.errors.password,
            }
          )}
        />
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div> */}
      <div className='fv-row mb-3'>
        <div className='input-group'>
          <input
            type={passwordVisible ? 'text' : 'password'} // Toggle between text and password
            placeholder='Password'
            autoComplete='off'
            {...formik.getFieldProps('password')}
            onChange={(e) => {
              // Trim the input value
              e.target.value = e.target.value.trim();
              // Update Formik state
              formik.handleChange(e);
            }}
            onKeyDown={(e) => {
              // List of characters to block
              const forbiddenChars = ['<', '>', '.', '?', '/', '\\', '"', "'", ':', ';', ','];
              if (forbiddenChars.includes(e.key)) {
                e.preventDefault(); // Prevent the input
              }
            }}
            className={clsx(
              'form-control bg-transparent',
              {
                'is-invalid': formik.touched.password && formik.errors.password,
              },
              {
                'is-valid': formik.touched.password && !formik.errors.password,
              }
            )}
          />
          <button
            type="button"
            className="input-group-text"
            onClick={() => setPasswordVisible(!passwordVisible)}
          >
            {passwordVisible ? (
              <i className="bi bi-eye-slash"></i> // Eye slash icon when password is visible
            ) : (
              <i className="bi bi-eye"></i> // Eye icon when password is hidden
            )}
          </button>
        </div>
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>

      {/* end::Form group */}

      {/* begin::Wrapper */}
      <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8'>
        <div />

        {/* begin::Link */}
        {/* <Link to='/auth/forgot-password' className='link-primary'>
          Forgot Password ?
        </Link> */}
        {/* end::Link */}
      </div>
      {/* end::Wrapper */}

      {/* begin::Action */}
      <div className='d-grid mb-10'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-primary'
        // disabled={loading || formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>Login</span>}
          {loading && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      <ToastContainer className='p-3' position={'top-end'}>
        <Toast
          show={sessionMessage.show}
          onClose={() => {
            setSessionMessage({
              type: '',
              message: '',
              show: false,
            })
          }}
          bg='danger'
        >
          {/* <Toast.Header>Error</Toast.Header> */}
          <Toast.Body className='text-white'>{sessionMessage.message}</Toast.Body>
        </Toast>
      </ToastContainer>
    </form>
  )
}